import { render, staticRenderFns } from "./co-market-items.vue?vue&type=template&id=33a233ee&"
import script from "./co-market-items.vue?vue&type=script&lang=ts&"
export * from "./co-market-items.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports